import React from 'react';

export const PageClose = () => {
    return <div>
        <p>Пожалуйста, закройте остальные вкладки сайта Дорогой Добра и перезагрузите страницу!</p>
    </div>;
}